import { api } from "@/lib/api";

/**
 * Antes de imprimir o boleto FEBRABAN:
 * 1. Injeta um <style> temporário com @page 108mm × 175mm (1/4 ofício).
 * 2. Chama window.print().
 * 3. Remove o <style> ao terminar.
 */
export function printBoletoWithPageSize() {
  const STYLE_ID = "boleto-print-page-size";
  document.getElementById(STYLE_ID)?.remove();
  const style = document.createElement("style");
  style.id = STYLE_ID;
  style.media = "print";
  style.appendChild(
    document.createTextNode("@page { size: 108mm 175mm; margin: 2mm; }")
  );
  document.head.appendChild(style);

  const cleanup = () => {
    document.getElementById(STYLE_ID)?.remove();
    window.removeEventListener("afterprint", cleanup);
  };
  window.addEventListener("afterprint", cleanup);

  window.print();
  // Fallback caso afterprint não dispare em alguns browsers
  setTimeout(cleanup, 3000);
}

/**
 * Busca o beneficiário (VM Piabetá) do backend — endpoint público.
 */
export async function fetchBeneficiario() {
  try {
    const { data } = await api.get("/config/beneficiario");
    return data;
  } catch {
    return null;
  }
}

/**
 * Garante a cobrança BolePix do Banco Inter (Pix + boleto oficial) — idempotente.
 * `scope`: "admin" | "lojista". Lança erro (com detalhe do backend) se o Inter falhar.
 */
export async function prepararPix(boletoId, scope = "admin") {
  const url = scope === "lojista"
    ? `/pagamentos/lojista/pix/preparar/${boletoId}`
    : `/pagamentos/pix/preparar/${boletoId}`;
  const { data } = await api.post(url);
  return data;
}

/** Junta a fatura com os dados oficiais da cobrança Inter para impressão. */
export function mesclarPix(boleto, pix) {
  if (!pix) return boleto;
  return {
    ...boleto,
    pix_copia_cola: pix.copia_cola,
    pix_qr_code_base64: pix.qr_code_base64,
    linha_digitavel: pix.linha_digitavel,
    codigo_barras: pix.codigo_barras,
    nosso_numero: pix.nosso_numero,
    vencimento_cobranca: pix.vencimento_cobranca,
    valor_cobrado: pix.valor,
  };
}
